export const REPLACEMENT_TEXT = {
  NICKNAME: '{{nickname}}',
  MAIL_ADDRESS: '{{mailAddress}}',
  GAME: '{{game}}',
  DOWNLOAD_URL: '{{downloadUrl}}',
};

export const ROUTES = {
  top: '/top',
  topGacha: '/top/gacha',
  topGachaCreate: '/top/gacha/create',
  topEmailSend: '/top/email/send',
  topExportAllRegistersAsCsv: '/top/export-all-registers-as-csv',
};
